import { BsCaretDownFill as CaretDownIcon } from 'react-icons/bs';
import { ReactComponent as GPCFolderIcon } from 'images/google-folder.svg';
import React from 'react';
import Button from 'react-bootstrap/Button';
import FormCheck from 'react-bootstrap/FormCheck';
import Collapse from 'react-bootstrap/Collapse';
import ListGroup from 'react-bootstrap/ListGroup';
import _ from 'lodash';
import { TreeNode } from './tree-node';
import {
  useIsItemSelected, useParsedQueryString, useSmartNestedDepth, useToggleFolderSelection,
} from './hooks';
import * as context from './context';

const checkIfShouldBeOpen = ({
  baseOpen, filter, title, expandAll,
}) => (
  !!expandAll || !!(baseOpen || (filter && !_.includes(_.toLower(title), _.toLower(_.trim(filter)))))
);

export const ParentItem = ({ title, id, folder }) => {
  const expandAll = useParsedQueryString()?.expandAll || false;
  const { depth, paddingLeft } = useSmartNestedDepth();
  const checkRef = React.useRef(null);
  const checkId = `folder-id-check-${id}`;
  const childrenId = `folder-id-${id}-children`;
  const filter = React.useContext(context.filter)?.filter;
  const { selected, indeterminate } = useIsItemSelected(id, folder) || {};
  const onSelect = useToggleFolderSelection();
  const [baseOpen, setOpen] = React.useState(false);
  const isOpen = checkIfShouldBeOpen({
    expandAll, baseOpen, filter, title,
  });
  React.useEffect(() => {
    _.set(checkRef, 'current.indeterminate', !!indeterminate);
  }, [indeterminate, checkRef]);
  return (
    <context.depth.Provider value={{ depth }}>
      <ListGroup.Item as="li" className={`parent-list-item parent-list-item--${isOpen ? 'open' : 'closed'}`}>
        <div className="rax-mgcp-parent-listitem-grid" style={{ paddingLeft }}>
          <FormCheck value={id} id={checkId} checked={selected} ref={checkRef} onChange={onSelect} className="check-wrapper" />

          <GPCFolderIcon title="GCP Folder" role="img" className="project-icon" />

          <a onClick={(e) => ([e.preventDefault(), setOpen(!isOpen)])} href="#open-close" className="project-title cursor-pointer text-truncate" title={title}>{title}</a>

          <small className="project-id text-muted text-truncate" title={id}>{id}</small>

          <Button
            variant="plain"
            onClick={() => setOpen(!isOpen)}
            aria-controls={childrenId}
            aria-expanded={isOpen}
            className="align-self-center"
          >
            <CaretDownIcon role="img" title="Expand/Collapse Folder" className="text-gray800" />
          </Button>
        </div>

        <Collapse timeout={0} in={isOpen}>
          <ListGroup id={childrenId} className="sub-list-group" as="ul" variant="flush">
            {isOpen && (<TreeNode targetFolder={`${id}`} />)}
          </ListGroup>
        </Collapse>

      </ListGroup.Item>
    </context.depth.Provider>
  );
};
